export default {
    workCenter:undefined,
    workCenterOptions:[],
    importOptions:[],
    loading: false,
    error: null,
    errorShow: false
}